import type { Schemas } from "../workspace/api.generated";

/** Display only the original payment's provider-supplied name and masked last four digits. */
export function paymentCardLabel(detail: Schemas["TransactionAdminDetailView"]): string {
  const payment = detail.paymentSummary;
  const approved = Boolean(
    detail.transaction.paymentApprovedAt || payment?.approvedAt ||
    ["APPROVED", "CANCELED"].includes(detail.transaction.paymentStatus ?? "") ||
    ["APPROVED", "CANCELED"].includes(payment?.status ?? ""),
  );
  if (!approved) return "결제 전";

  const rawName = payment?.cardCompanyName?.trim();
  const name = rawName && !["CARD", "CREDITCARD"].includes(rawName.toUpperCase()) ? rawName : undefined;
  const instrument = payment?.instrumentMasked?.trim() ?? "";
  const normalized = instrument.replace(/[ -]/g, "");
  const lastFour = /^(?:\*{4}\d{4}|[\d*]{8,15}\d{4}|\d{4})$/.test(normalized) &&
    (normalized.includes("*") || normalized.length === 4)
    ? normalized.match(/(\d{4})$/)?.[1]
    : undefined;
  if (lastFour) return `${name ?? "신용카드"} · ****${lastFour}`;
  return name ? `${name} · 카드번호 미제공` : "신용카드 · 카드 상세정보 미제공";
}
